import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthProvider } from '../src/contexts/AuthContext'
import { FilesProvider } from './contexts/FilesContext'
import { GuestContextProvider } from './contexts/GuestContext'
import { DragProvider } from './contexts/dragContext'
import { UserProfileProvider } from './contexts/UserProfileContext'
import { HistoryProvider } from './contexts/HistoryContext'
import { LayoutProvider } from './contexts/LayoutContext'
import { CVProvider } from './contexts/CVContext'
import { ProfileProvider } from './contexts/ProfileContext'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    {' '}
    <AuthProvider>
      <LayoutProvider>
        <FilesProvider>
          <HistoryProvider>
            <UserProfileProvider>
              <GuestContextProvider>
                <DragProvider>
                  <CVProvider>
                    <ProfileProvider>
                      <App />
                    </ProfileProvider>
                  </CVProvider>
                </DragProvider>
              </GuestContextProvider>
            </UserProfileProvider>
          </HistoryProvider>
        </FilesProvider>
      </LayoutProvider>
    </AuthProvider>
  </React.StrictMode>
)

reportWebVitals()
